var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4696 5.10299C14.076 4.19468 13.4742 3.38051 12.7077 2.71931C11.9411 2.05811 11.0289 1.56641 10.0371 1.27975C9.04525 0.993094 7.99852 0.918643 6.97257 1.06178C5.94663 1.20492 4.96709 1.56206 4.10477 2.1074C3.24245 2.65274 2.5189 3.37265 1.98642 4.21509C1.45393 5.05753 1.12582 6.00144 1.0258 6.97861C0.925779 7.95577 1.05635 8.94176 1.40807 9.86531C1.75979 10.7889 2.32388 11.6269 3.05955 12.3188L8.00622 17.0091L12.9529 12.3188C13.9349 11.3952 14.6038 10.2153 14.8739 8.92993C15.1441 7.64459 15.0033 6.31219 14.4696 5.10299ZM10.2073 9.71965C9.69868 10.2017 9.0292 10.5019 8.31297 10.5691C7.59674 10.6363 6.87805 10.4663 6.27936 10.0881C5.68068 9.70989 5.23902 9.14687 5.02965 8.49497C4.82028 7.84307 4.85614 7.14262 5.13113 6.51294C5.40612 5.88326 5.90321 5.36333 6.53773 5.04171C7.17225 4.7201 7.90493 4.6167 8.61094 4.74914C9.31696 4.88158 9.95262 5.24167 10.4096 5.76804C10.8667 6.29442 11.1168 6.95452 11.1173 7.63589C11.1177 8.02278 11.0374 8.40594 10.8813 8.76347C10.7252 9.12101 10.4961 9.44592 10.2073 9.71965Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildLocation);
export default __webpack_public_path__ + "static/media/buildLocation.7d6c61a05f8e87d5a2ae8aa79b2d94f5.svg";
export { ForwardRef as ReactComponent };